<app-overlay-loader [show]="isLoading"></app-overlay-loader>
<app-header></app-header>

<!-- Delete Confirmation Popup -->
<div class="delete-confirmation-overlay" *ngIf="showDeleteConfirmation" (click)="onCancelDelete()">
    <div class="delete-confirmation-popup" (click)="$event.stopPropagation()">
        <div class="delete-confirmation-header">
            <h3 class="delete-confirmation-title">Confirm Delete</h3>
        </div>
        <div class="delete-confirmation-body">
            <p class="delete-confirmation-message">Are you sure you want to delete?</p>
        </div>
        <div class="delete-confirmation-footer">
            <button class="delete-confirmation-button delete-confirmation-button-cancel" type="button" (click)="onCancelDelete()">
                Cancel
            </button>
            <button class="delete-confirmation-button delete-confirmation-button-confirm" type="button" (click)="onConfirmDelete()">
                Delete
            </button>
        </div>
    </div>
</div>

<!-- Face Compare / Video Scanner detail overlays removed:
     row click now navigates into the feature result UI (detector / scanned-results). -->

<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container">
        <!-- HISTORY TYPE TABS -->
        <div class="row">
            <div class="col-12 p-sm-0">
                <div class="search-history-type-buttons mt-3">
                    <button type="button" class="search-history-type-button" [ngClass]="{
            'search-history-type-button-active':
              historyTab.type === selectedHistoryTab.type
          }" *ngFor="let historyTab of historyTabs" (click)="onHistoryTypeTabClick(historyTab)">
                        {{ historyTab.label }}
                    </button>
                </div>
            </div>
        </div>

        <!-- IMAGE HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'image'">
            <div class="col-12 p-sm-0">
                <div class="row p-3">
                    <div class="col-12 col-sm-7 col-lg-6 ps-sm-0">
                        <div class="search-history-type-images-filters-wrapper">
                            <select class="search-history-filters-select" [(ngModel)]="selectedImageFilter" (ngModelChange)="onImageFilterChange()">
                                <option class="search-history-filters-option" *ngFor="let imageFilter of imageFilters" [value]="imageFilter.value">
                                    {{ imageFilter.label }}
                                </option>
                            </select>

                            <!-- IMAGES HISTORY FILTERS -->

                            <input class="search-history-filters-input-type-text" *ngIf="
                selectedHistoryTab.type === 'image' &&
                selectedImageFilter === 'search-name'
              " type="text" placeholder="Search here" [(ngModel)]="imageHistorySearchNameFilter" (ngModelChange)="onImageHistorySearchNameFilterChange($event)" />

                            <div class="search-history-filters-input-type-date-wrapper" *ngIf="
                selectedHistoryTab.type === 'image' &&
                selectedImageFilter === 'created-on'
              ">
                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="imageHistoryStartDateFilter" (ngModelChange)="onImageHistoryStartDateFilterChange($event)" />

                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="imageHistoryEndDateFilter" (ngModelChange)="onImageHistoryEndDateFilterChange($event)" />
                            </div>

                            <div class="search-history-filters-input-type-radio-group" *ngIf="
                selectedHistoryTab.type === 'image' &&
                selectedImageFilter === 'status'
              ">
                                <input class="search-history-filters-input-type-radio-button" type="radio" value="all" [(ngModel)]="imageHistoryStatusFilter" (ngModelChange)="onImageHistoryStatusFilterChange($event)" />
                                <label class="search-history-filters-input-type-radio-button-label">
                                    All
                                </label>
                                <input class="search-history-filters-input-type-radio-button" type="radio" value="success" [(ngModel)]="imageHistoryStatusFilter" (ngModelChange)="onImageHistoryStatusFilterChange($event)" />
                                <label class="search-history-filters-input-type-radio-button-label">
                                    Success
                                </label>
                                <input class="search-history-filters-input-type-radio-button" type="radio" value="pending" [(ngModel)]="imageHistoryStatusFilter" (ngModelChange)="onImageHistoryStatusFilterChange($event)" />
                                <label class="search-history-filters-input-type-radio-button-label">
                                    Pending
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-5 col-lg-6 pe-sm-0 mt-2 mt-sm-0">
                        <div class="search-history-type-images-buttons-wrapper">
                            <button class="search-history-type-images-select-all-button" [ngClass]="{
                'search-history-type-images-select-all-button-disabled':
                  imageHistoriesPaged.length === 0
              }" type="button" [disabled]="imageHistoriesPaged.length === 0" (click)="onImageHistoriesSelectAllButtonClick()">
                                <span *ngIf="!imageHistoriesSelectAll.isSelected">
                                    <i class="fas fa-check-square"></i>
                                    Select All
                                </span>
                                <span *ngIf="imageHistoriesSelectAll.isSelected">
                                    <i class="far fa-square"></i>
                                    Deselect All
                                </span>
                            </button>
                            <button class="search-history-type-images-delete-all-button" [ngClass]="{
                'search-history-type-images-delete-all-button-disabled':
                  imageHistoriesPaged.length === 0
              }" type="button" [disabled]="imageHistoriesPaged.length === 0" (click)="onImageHistoriesDeleteButtonClick()">
                                <i class="fas fa-trash"></i>
                                {{ deleteButtonLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-type-images">
                    <div class="search-history-type-image" *ngFor="let imageHistoryPaged of imageHistoriesPaged">
                        <div class="search-history-type-image-headshot-wrapper">
                            <img class="search-history-type-image-headshot" [src]="imageHistoryPaged.thumbnail || 'https://placehold.co/400x400'" [alt]="imageHistoryPaged.job_name || 'Image History'" (click)="onImageHistoryHeadshotClick(imageHistoryPaged)" />
                            <input class="search-history-type-image-checkbox" type="checkbox" [checked]="imageHistoryPaged.isSelected" (click)="onImageHistoryPagedClick($event, imageHistoryPaged)" />
                        </div>
                        <div class="search-history-type-image-details">
                            <div class="search-history-type-image-search-term">
                                {{ imageHistoryPaged.job_name }}
                            </div>
                            <div class="search-history-type-image-search-timestamp">
                                {{ imageHistoriesFormatDate(imageHistoryPaged.created_on) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ imageHistoriesPagedStartAndEnd.start }} - {{ imageHistoriesPagedStartAndEnd.end }} of {{
            imageHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="imageHistoriesCount" [itemsPerPage]="imageHistoriesPerPage" [currentPage]="imageHistoriesCurrentPage" (pageChange)="onImageHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- FACE COMPARE HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'face-compare'">
            <div class="col-12 p-sm-0">
                <div class="row p-3">
                    <div class="col-12 col-sm-7 col-lg-6 ps-sm-0">
                        <div class="search-history-type-images-filters-wrapper">
                            <select class="search-history-filters-select" [(ngModel)]="selectedFaceCompareFilter" (ngModelChange)="onFaceCompareFilterChange()">
                                <option class="search-history-filters-option" *ngFor="let faceCompareFilter of faceCompareFilters" [value]="faceCompareFilter.value">
                                    {{ faceCompareFilter.label }}
                                </option>
                            </select>

                            <input class="search-history-filters-input-type-text" *ngIf="
                selectedHistoryTab.type === 'face-compare' &&
                selectedFaceCompareFilter === 'file-name'
              " type="text" placeholder="Search by file name" [(ngModel)]="faceCompareHistoryFileNameFilter" (ngModelChange)="onFaceCompareHistoryFileNameFilterChange($event)" />

                            <input class="search-history-filters-input-type-text" *ngIf="
                selectedHistoryTab.type === 'face-compare' &&
                selectedFaceCompareFilter === 'notes'
              " type="text" placeholder="Search by notes" [(ngModel)]="faceCompareHistoryNotesFilter" (ngModelChange)="onFaceCompareHistoryNotesFilterChange($event)" />

                            <div class="search-history-filters-input-type-date-wrapper" *ngIf="
                selectedHistoryTab.type === 'face-compare' &&
                selectedFaceCompareFilter === 'created-on'
              ">
                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="faceCompareHistoryStartDateFilter" (ngModelChange)="onFaceCompareHistoryStartDateFilterChange($event)" />
                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="faceCompareHistoryEndDateFilter" (ngModelChange)="onFaceCompareHistoryEndDateFilterChange($event)" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-5 col-lg-6 pe-sm-0 mt-2 mt-sm-0">
                        <div class="search-history-type-images-buttons-wrapper">
                            <button class="search-history-type-images-select-all-button" [ngClass]="{
                'search-history-type-images-select-all-button-disabled':
                  faceCompareHistoriesPaged.length === 0
              }" type="button" [disabled]="faceCompareHistoriesPaged.length === 0" (click)="onFaceCompareHistoriesSelectAllButtonClick()">
                                <span *ngIf="!faceCompareHistoriesSelectAll.isSelected">
                                    <i class="fas fa-check-square"></i>
                                    Select All
                                </span>
                                <span *ngIf="faceCompareHistoriesSelectAll.isSelected">
                                    <i class="far fa-square"></i>
                                    Deselect All
                                </span>
                            </button>
                            <button class="search-history-type-images-delete-all-button" [ngClass]="{
                'search-history-type-images-delete-all-button-disabled':
                  faceCompareHistoriesPaged.length === 0
              }" type="button" [disabled]="faceCompareHistoriesPaged.length === 0" (click)="onFaceCompareHistoriesDeleteButtonClick()">
                                <i class="fas fa-trash"></i>
                                {{ deleteButtonLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-type-face-compares">
                    <div class="search-history-type-face-compare" *ngFor="let faceCompareHistoryPaged of faceCompareHistoriesPaged">
                        <div class="search-history-type-face-compare-thumbs" (click)="onFaceCompareCardClick(faceCompareHistoryPaged)">
                            <img
                                class="search-history-type-face-compare-thumb"
                                [src]="faceCompareHistoryPaged.image_a_url || 'https://placehold.co/200x200?text=A'"
                                [alt]="faceCompareHistoryPaged.image_a_file_name || 'Image A'"
                                (error)="onFaceCompareDetailImageError($event)"
                            />
                            <img
                                class="search-history-type-face-compare-thumb"
                                [src]="faceCompareHistoryPaged.image_b_url || 'https://placehold.co/200x200?text=B'"
                                [alt]="faceCompareHistoryPaged.image_b_file_name || 'Image B'"
                                (error)="onFaceCompareDetailImageError($event)"
                            />
                            <input class="search-history-type-image-checkbox" type="checkbox" [checked]="faceCompareHistoryPaged.isSelected" (click)="onFaceCompareHistoryPagedClick($event, faceCompareHistoryPaged)" />
                        </div>
                        <div class="search-history-type-face-compare-details" (click)="onFaceCompareCardClick(faceCompareHistoryPaged)">
                            <div class="search-history-type-face-compare-match">
                                {{ formatFaceCompareMatch(faceCompareHistoryPaged.match) }}
                                ·
                                {{ formatFaceCompareProbability(faceCompareHistoryPaged.probability) }}
                            </div>
                            <div class="search-history-type-image-search-timestamp" [title]="formatFaceCompareNotes(faceCompareHistoryPaged)">
                                {{ formatFaceCompareNotes(faceCompareHistoryPaged) }}
                            </div>
                            <div class="search-history-type-image-search-timestamp">
                                {{ faceCompareHistoriesFormatDate(faceCompareHistoryPaged.created_on) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ faceCompareHistoriesPagedStartAndEnd.start }} - {{ faceCompareHistoriesPagedStartAndEnd.end }} of {{
            faceCompareHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="faceCompareHistoriesCount" [itemsPerPage]="faceCompareHistoriesPerPage" [currentPage]="faceCompareHistoriesCurrentPage" (pageChange)="onFaceCompareHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- VIDEO SCANNER HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'video-scanner'">
            <div class="col-12 p-sm-0">
                <div class="row p-3">
                    <div class="col-12 col-sm-7 col-lg-6 ps-sm-0">
                        <div class="search-history-type-images-filters-wrapper">
                            <select class="search-history-filters-select" [(ngModel)]="selectedVideoScannerFilter" (ngModelChange)="onVideoScannerFilterChange()">
                                <option class="search-history-filters-option" *ngFor="let videoScannerFilter of videoScannerFilters" [value]="videoScannerFilter.value">
                                    {{ videoScannerFilter.label }}
                                </option>
                            </select>

                            <input class="search-history-filters-input-type-text" *ngIf="
                selectedHistoryTab.type === 'video-scanner' &&
                selectedVideoScannerFilter === 'video-name'
              " type="text" placeholder="Search by video name" [(ngModel)]="videoScannerHistoryVideoNameFilter" (ngModelChange)="onVideoScannerHistoryVideoNameFilterChange($event)" />

                            <div class="search-history-filters-input-type-date-wrapper" *ngIf="
                selectedHistoryTab.type === 'video-scanner' &&
                selectedVideoScannerFilter === 'created-on'
              ">
                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="videoScannerHistoryStartDateFilter" (ngModelChange)="onVideoScannerHistoryStartDateFilterChange($event)" />
                                <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="videoScannerHistoryEndDateFilter" (ngModelChange)="onVideoScannerHistoryEndDateFilterChange($event)" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-5 col-lg-6 pe-sm-0 mt-2 mt-sm-0">
                        <div class="search-history-type-images-buttons-wrapper">
                            <button class="search-history-type-images-select-all-button" [ngClass]="{
                'search-history-type-images-select-all-button-disabled':
                  videoScannerHistoriesPaged.length === 0
              }" type="button" [disabled]="videoScannerHistoriesPaged.length === 0" (click)="onVideoScannerHistoriesSelectAllButtonClick()">
                                <span *ngIf="!videoScannerHistoriesSelectAll.isSelected">
                                    <i class="fas fa-check-square"></i>
                                    Select All
                                </span>
                                <span *ngIf="videoScannerHistoriesSelectAll.isSelected">
                                    <i class="far fa-square"></i>
                                    Deselect All
                                </span>
                            </button>
                            <button class="search-history-type-images-delete-all-button" [ngClass]="{
                'search-history-type-images-delete-all-button-disabled':
                  videoScannerHistoriesPaged.length === 0
              }" type="button" [disabled]="videoScannerHistoriesPaged.length === 0" (click)="onVideoScannerHistoriesDeleteButtonClick()">
                                <i class="fas fa-trash"></i>
                                {{ deleteButtonLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-type-face-compares">
                    <div class="search-history-type-face-compare" *ngFor="let videoScannerHistoryPaged of videoScannerHistoriesPaged">
                        <div class="search-history-type-video-scanner-thumb" (click)="onVideoScannerCardClick(videoScannerHistoryPaged)">
                            <i class="fas fa-video search-history-type-video-scanner-icon"></i>
                            <input class="search-history-type-image-checkbox" type="checkbox" [checked]="videoScannerHistoryPaged.isSelected" (click)="onVideoScannerHistoryPagedClick($event, videoScannerHistoryPaged)" />
                        </div>
                        <div class="search-history-type-face-compare-details" (click)="onVideoScannerCardClick(videoScannerHistoryPaged)">
                            <div class="search-history-type-face-compare-match">
                                {{ videoScannerHistoryPaged.video_name || 'Untitled video' }}
                            </div>
                            <div class="search-history-type-image-search-timestamp">
                                {{ videoScannerHistoryPaged.frames_scanned ?? 0 }} frames ·
                                {{ videoScannerHistoryPaged.faces_found ?? 0 }} faces ·
                                {{ videoScannerHistoryPaged.credits_used ?? 0 }} credits
                            </div>
                            <div class="search-history-type-image-search-timestamp">
                                {{ formatVideoScannerStatus(videoScannerHistoryPaged.status) }} ·
                                {{ videoScannerHistoriesFormatDate(videoScannerHistoryPaged.created_on) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ videoScannerHistoriesPagedStartAndEnd.start }} - {{ videoScannerHistoriesPagedStartAndEnd.end }} of {{
            videoScannerHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="videoScannerHistoriesCount" [itemsPerPage]="videoScannerHistoriesPerPage" [currentPage]="videoScannerHistoriesCurrentPage" (pageChange)="onVideoScannerHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>


        <!-- OSINT AND LEAK FILTERS AND EXPORTS -->
        <div class="row py-4" *ngIf="
      selectedHistoryTab.type === 'osint-phone' ||
      selectedHistoryTab.type === 'osint-email' ||
      selectedHistoryTab.type === 'leak-phone' ||
      selectedHistoryTab.type === 'osint-username' ||
      selectedHistoryTab.type === 'osint-name' ||
      selectedHistoryTab.type === 'osint-wallet' ||
      selectedHistoryTab.type === 'leak-email' ||
      selectedHistoryTab.type === 'leak-username' ||
      selectedHistoryTab.type === 'leak-password' ||
      selectedHistoryTab.type === 'vehicle' ||
      selectedHistoryTab.type === 'pan' ||
      selectedHistoryTab.type === 'gst' ||
      selectedHistoryTab.type === 'din' ||
      selectedHistoryTab.type === 'mobile-pan' ||
      selectedHistoryTab.type === 'phonepe_fastag' ||
      selectedHistoryTab.type === 'phonepe_upi' ||
      selectedHistoryTab.type === 'virtual-number' ||
      selectedHistoryTab.type === 'advanced-search' ||
      selectedHistoryTab.type === 'basic-search' ||
      selectedHistoryTab.type === 'web-search' ||
      selectedHistoryTab.type === 'link-analysis'
    ">
            <!-- FILTERS -->
            <div class="col-12 col-sm-5 col-md-6 col-lg-5 ps-sm-0">
                <div class="search-history-filters-wrapper">
                    <select class="search-history-filters-select" [(ngModel)]="selectedOsintAndLeakFilter" (ngModelChange)="onOsintAndLeakHistoryFilterChange()">
                        <option class="search-history-filters-option" *ngFor="let osintAndLeakFilter of osintAndLeakFilters" [value]="osintAndLeakFilter.value">
                            {{ osintAndLeakFilter.label }}
                        </option>
                    </select>

                    <!-- OSINT FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'phone'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryPhoneFilter" (ngModelChange)="onOsintHistoryPhoneFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'email'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryEmailFilter" (ngModelChange)="onOsintHistoryEmailFilterChange($event)" />
                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'username'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryUsernameFilter" (ngModelChange)="onOsintHistoryUsernameFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'name'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryNameFilter" (ngModelChange)="onOsintHistoryNameFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'wallet'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryWalletFilter" (ngModelChange)="onOsintHistoryWalletFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'gst'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryGstFilter" (ngModelChange)="onOsintHistoryGstFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'din'
          " type="text" placeholder="Search here" [(ngModel)]="osintHistoryDinFilter" (ngModelChange)="onOsintHistoryDinFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedOsintHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="osintHistoryStartDateFilter" (ngModelChange)="onOsintHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="osintHistoryEndDateFilter" (ngModelChange)="onOsintHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- LEAK FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedLeakHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'phone'
          " type="text" placeholder="Search here" [(ngModel)]="leakHistoryPhoneFilter" (ngModelChange)="onLeakHistoryPhoneFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedLeakHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'email'
          " type="text" placeholder="Search here" [(ngModel)]="leakHistoryEmailFilter" (ngModelChange)="onLeakHistoryEmailFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedLeakHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'username'
          " type="text" placeholder="Search here" [(ngModel)]="leakHistoryUsernameFilter" (ngModelChange)="onLeakHistoryUsernameFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedLeakHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'password'
          " type="text" placeholder="Search here" [(ngModel)]="leakHistoryPasswordFilter" (ngModelChange)="onLeakHistoryPasswordFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedLeakHistoryType !== '' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="leakHistoryStartDateFilter" (ngModelChange)="onLeakHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="leakHistoryEndDateFilter" (ngModelChange)="onLeakHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- VEHICLE FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'vehicle' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="vehicleHistoryIdFilter" (ngModelChange)="onVehicleHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'vehicle' &&
            selectedOsintAndLeakFilter === 'vehicle-number'
          " type="text" placeholder="Search here" [(ngModel)]="vehicleHistoryVehicleNumberFilter" (ngModelChange)="onVehicleHistoryVehicleNumberFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'vehicle' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="vehicleHistoryStartDateFilter" (ngModelChange)="onVehicleHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="vehicleHistoryEndDateFilter" (ngModelChange)="onVehicleHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- PAN FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'pan' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="panHistoryIdFilter" (ngModelChange)="onPanHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'pan' &&
            selectedOsintAndLeakFilter === 'pan-number'
          " type="text" placeholder="Search here" [(ngModel)]="panHistoryPanNumberFilter" (ngModelChange)="onPanHistoryPanNumberFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'pan' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="panHistoryStartDateFilter" (ngModelChange)="onPanHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="panHistoryEndDateFilter" (ngModelChange)="onPanHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- GST FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'gst' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="gstHistoryIdFilter" (ngModelChange)="onGstHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'gst' &&
            selectedOsintAndLeakFilter === 'gst'
          " type="text" placeholder="Search here" [(ngModel)]="gstHistoryGstFilter" (ngModelChange)="onGstHistoryGstFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'gst' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="gstHistoryStartDateFilter" (ngModelChange)="onGstHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="gstHistoryEndDateFilter" (ngModelChange)="onGstHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- DIN FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'din' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="dinHistoryIdFilter" (ngModelChange)="onDinHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'mobile-pan' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="mobilePanHistoryIdFilter" (ngModelChange)="onMobilePanHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'din' &&
            selectedOsintAndLeakFilter === 'din'
          " type="text" placeholder="Search here" [(ngModel)]="dinHistoryDinFilter" (ngModelChange)="onDinHistoryDinFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'din' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="dinHistoryStartDateFilter" (ngModelChange)="onDinHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="dinHistoryEndDateFilter" (ngModelChange)="onDinHistoryEndDateFilterChange($event)" />
                    </div>

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'mobile-pan' &&
            selectedOsintAndLeakFilter === 'phone'
          " type="text" placeholder="Search here" [(ngModel)]="mobilePanHistoryPhoneFilter" (ngModelChange)="onMobilePanHistoryPhoneFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'mobile-pan' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="mobilePanHistoryStartDateFilter" (ngModelChange)="onMobilePanHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="mobilePanHistoryEndDateFilter" (ngModelChange)="onMobilePanHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- PHONEPE FASTAG FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'phonepe_fastag' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="phonepeFastagHistoryIdFilter" (ngModelChange)="onPhonepeFastagHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'phonepe_fastag' &&
            selectedOsintAndLeakFilter === 'vehicle'
          " type="text" placeholder="Search here" [(ngModel)]="phonepeFastagHistoryVehicleFilter" (ngModelChange)="onPhonepeFastagHistoryVehicleFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'phonepe_fastag' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="phonepeFastagHistoryStartDateFilter" (ngModelChange)="onPhonepeFastagHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="phonepeFastagHistoryEndDateFilter" (ngModelChange)="onPhonepeFastagHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- PHONEPE UPI FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'phonepe_upi' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="phonepeUpiHistoryIdFilter" (ngModelChange)="onPhonepeUpiHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'phonepe_upi' &&
            selectedOsintAndLeakFilter === 'vpa'
          " type="text" placeholder="Search here" [(ngModel)]="phonepeUpiHistoryVpaFilter" (ngModelChange)="onPhonepeUpiHistoryVpaFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'phonepe_upi' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="phonepeUpiHistoryStartDateFilter" (ngModelChange)="onPhonepeUpiHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="phonepeUpiHistoryEndDateFilter" (ngModelChange)="onPhonepeUpiHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- VIRTUAL NUMBER FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'virtual-number' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="virtualNumberHistoryIdFilter" (ngModelChange)="onVirtualNumberHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'virtual-number' &&
            selectedOsintAndLeakFilter === 'virtual-number'
          " type="text" placeholder="Search here" [(ngModel)]="virtualNumberHistoryVirtualNumberFilter" (ngModelChange)="onVirtualNumberHistoryVirtualNumberFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'virtual-number' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="virtualNumberHistoryStartDateFilter" (ngModelChange)="onVirtualNumberHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="virtualNumberHistoryEndDateFilter" (ngModelChange)="onVirtualNumberHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- ADVANCED SEARCH FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'advanced-search' &&
            selectedOsintAndLeakFilter === 'id'
          " type="text" placeholder="Search here" [(ngModel)]="advancedSearchHistoryIdFilter" (ngModelChange)="onAdvancedSearchHistoryIdFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'advanced-search' &&
            selectedOsintAndLeakFilter === 'search-name'
          " type="text" placeholder="Search here" [(ngModel)]="advancedSearchHistorySearchNameFilter" (ngModelChange)="onAdvancedSearchHistorySearchNameFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'advanced-search' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="advancedSearchHistoryStartDateFilter" (ngModelChange)="onAdvancedSearchHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="advancedSearchHistoryEndDateFilter" (ngModelChange)="onAdvancedSearchHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- BASIC SEARCH FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'basic-search' &&
            selectedOsintAndLeakFilter === 'phone'
          " type="text" placeholder="Search here" [(ngModel)]="basicSearchHistoryPhoneFilter" (ngModelChange)="onBasicSearchHistoryPhoneFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'basic-search' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="basicSearchHistoryStartDateFilter" (ngModelChange)="onBasicSearchHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="basicSearchHistoryEndDateFilter" (ngModelChange)="onBasicSearchHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- WEB SEARCH FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'web-search' &&
            selectedOsintAndLeakFilter === 'url'
          " type="text" placeholder="Search here" [(ngModel)]="webSearchHistoryUrlFilter" (ngModelChange)="onWebSearchHistoryUrlFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'web-search' &&
            selectedOsintAndLeakFilter === 'domain'
          " type="text" placeholder="Search here" [(ngModel)]="webSearchHistoryDomainFilter" (ngModelChange)="onWebSearchHistoryDomainFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'web-search' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="webSearchHistoryStartDateFilter" (ngModelChange)="onWebSearchHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="webSearchHistoryEndDateFilter" (ngModelChange)="onWebSearchHistoryEndDateFilterChange($event)" />
                    </div>

                    <!-- LINK ANALYSIS FILTERS -->

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'link-analysis' &&
            selectedOsintAndLeakFilter === 'root-value'
          " type="text" placeholder="Search root value" [(ngModel)]="linkAnalysisRootValueFilter" (ngModelChange)="onLinkAnalysisRootValueFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'link-analysis' &&
            selectedOsintAndLeakFilter === 'root-type'
          " type="text" placeholder="phone, email, username" [(ngModel)]="linkAnalysisRootTypeFilter" (ngModelChange)="onLinkAnalysisRootTypeFilterChange($event)" />

                    <input class="search-history-filters-input-type-text" *ngIf="
            selectedHistoryTab.type === 'link-analysis' &&
            selectedOsintAndLeakFilter === 'status'
          " type="text" placeholder="pending, processing, completed, failed" [(ngModel)]="linkAnalysisStatusFilter" (ngModelChange)="onLinkAnalysisStatusFilterChange($event)" />

                    <div class="search-history-filters-input-type-date-wrapper" *ngIf="
            selectedHistoryTab.type === 'link-analysis' &&
            selectedOsintAndLeakFilter === 'date-added'
          ">
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="linkAnalysisHistoryStartDateFilter" (ngModelChange)="onLinkAnalysisHistoryStartDateFilterChange($event)" />
                        <input class="search-history-filters-input-type-date" type="date" [(ngModel)]="linkAnalysisHistoryEndDateFilter" (ngModelChange)="onLinkAnalysisHistoryEndDateFilterChange($event)" />
                    </div>
                </div>
            </div>

            <!-- EXPORTS -->
            <div class="col-12 col-sm-7 col-md-6 col-lg-7 pe-sm-0 mt-2 mt-sm-0">
                <div class="search-history-export-buttons" *ngIf="selectedHistoryTab.type !== 'link-analysis'">
                    <button class="search-history-export-button export-excel-btn" type="button" (click)="onExportExcelButtonClick()">
                        <i class="fas fa-file-excel"></i>
                        Export Excel
                    </button>
                    <button class="search-history-export-button export-csv-btn" type="button" (click)="onExportCsvButtonClick()">
                        <i class="fas fa-file-csv"></i>
                        Export CSV
                    </button>
                    <button class="search-history-export-button export-pdf-btn" type="button" (click)="onExportPdfButtonClick()">
                        <i class="fas fa-file-pdf"></i>
                        Export PDF
                    </button>
                    <button class="search-history-delete-button" type="button" (click)="onDeleteButtonClick()">
                        <i class="fas fa-trash"></i>
                        {{ deleteButtonLabel }}
                    </button>
                </div>
            </div>
        </div>

        <!-- OSINT HISTORIES -->
        <div class="row" *ngIf="
      selectedHistoryTab.type === 'osint-phone' ||
      selectedHistoryTab.type === 'osint-email' ||
      selectedHistoryTab.type === 'osint-username' ||
      selectedHistoryTab.type === 'osint-name' ||
      selectedHistoryTab.type === 'osint-wallet'
    ">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="osintHistoriesSelectAll.isSelected" (click)="onOsintHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of selectedOsintHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let osintHistoryPaged of osintHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="osintHistoryPaged.isSelected" (click)="onOsintHistoryPagedClick($event, osintHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of selectedOsintHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ osintHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ osintHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <span
                                                  *ngIf="tableData.field === 'id' || tableData.field?.startsWith('searched_'); else plainOsintCell"
                                                  class="search-history-link"
                                                  (click)="goToOsintHistoryResult(osintHistoryPaged)"
                                                >{{ osintHistoryPaged[tableData.field] }}</span>
                                                <ng-template #plainOsintCell>
                                                  {{ osintHistoryPaged[tableData.field] }}
                                                </ng-template>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ osintHistoriesPagedStartAndEnd.start }} - {{ osintHistoriesPagedStartAndEnd.end }} of {{
            osintHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="osintHistoriesCount" [itemsPerPage]="osintHistoriesPerPage" [currentPage]="osintHistoriesCurrentPage" (pageChange)="onOsintHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- LEAK HISTORIES -->
        <div class="row" *ngIf="
      selectedHistoryTab.type === 'leak-phone' ||
      selectedHistoryTab.type === 'leak-email' ||
      selectedHistoryTab.type === 'leak-username' ||
      selectedHistoryTab.type === 'leak-password'
    ">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="leakHistoriesSelectAll.isSelected" (click)="onLeakHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of selectedLeakHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let leakHistoryPaged of leakHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="leakHistoryPaged.isSelected" (click)="onLeakHistoryPagedClick($event, leakHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of selectedLeakHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ leakHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ leakHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ leakHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ leakHistoriesPagedStartAndEnd.start }} - {{ leakHistoriesPagedStartAndEnd.end }} of {{
            leakHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="leakHistoriesCount" [itemsPerPage]="leakHistoriesPerPage" [currentPage]="leakHistoriesCurrentPage" (pageChange)="onLeakHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- VEHICLE HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'vehicle'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="vehicleHistoriesSelectAll.isSelected" (click)="onVehicleHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of vehicleHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let vehicleHistoryPaged of vehicleHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="vehicleHistoryPaged.isSelected" (click)="onVehicleHistoryPagedClick($event, vehicleHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of vehicleHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ vehicleHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ vehicleHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ vehicleHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ vehicleHistoriesPagedStartAndEnd.start }} - {{ vehicleHistoriesPagedStartAndEnd.end }} of {{
            vehicleHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="vehicleHistoriesCount" [itemsPerPage]="vehicleHistoriesPerPage" [currentPage]="vehicleHistoriesCurrentPage" (pageChange)="onVehicleHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- PAN HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'pan'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="panHistoriesSelectAll.isSelected" (click)="onPanHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of panHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let panHistoryPaged of panHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="panHistoryPaged.isSelected" (click)="onPanHistoryPagedClick($event, panHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of panHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ panHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ panHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ panHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ panHistoriesPagedStartAndEnd.start }} - {{ panHistoriesPagedStartAndEnd.end }} of {{
            panHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="panHistoriesCount" [itemsPerPage]="panHistoriesPerPage" [currentPage]="panHistoriesCurrentPage" (pageChange)="onPanHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- GST HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'gst'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="gstHistoriesSelectAll.isSelected" (click)="onGstHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of gstHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let gstHistoryPaged of gstHistoriesPaged" (click)="goToGstHistoryResult(gstHistoryPaged)" style="cursor: pointer;">
                                <td class="search-history-table-td" (click)="$event.stopPropagation()">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="gstHistoryPaged.isSelected" (click)="onGstHistoryPagedClick($event, gstHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of gstHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ gstHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ gstHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ gstHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ gstHistoriesPagedStartAndEnd.start }} - {{ gstHistoriesPagedStartAndEnd.end }} of {{
            gstHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="gstHistoriesCount" [itemsPerPage]="gstHistoriesPerPage" [currentPage]="gstHistoriesCurrentPage" (pageChange)="onGstHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>


        <!-- DIN HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'din'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="dinHistoriesSelectAll.isSelected" (click)="onDinHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of dinHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dinHistoryPaged of dinHistoriesPaged" (click)="goToDinHistoryResult(dinHistoryPaged)" style="cursor: pointer;">
                                <td class="search-history-table-td" (click)="$event.stopPropagation()">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="dinHistoryPaged.isSelected" (click)="onDinHistoryPagedClick($event, dinHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of dinHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ dinHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ dinHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ dinHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ dinHistoriesPagedStartAndEnd.start }} - {{ dinHistoriesPagedStartAndEnd.end }} of {{
            dinHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="dinHistoriesCount" [itemsPerPage]="dinHistoriesPerPage" [currentPage]="dinHistoriesCurrentPage" (pageChange)="onDinHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- MOBILE PAN HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'mobile-pan'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="mobilePanHistoriesSelectAll.isSelected" (click)="onMobilePanHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of mobilePanHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mobilePanHistoryPaged of mobilePanHistoriesPaged" (click)="goToMobilePanHistoryResult(mobilePanHistoryPaged)" style="cursor: pointer;">
                                <td class="search-history-table-td" (click)="$event.stopPropagation()">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="mobilePanHistoryPaged.isSelected" (click)="onMobilePanHistoryPagedClick($event, mobilePanHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of mobilePanHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ mobilePanHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ mobilePanHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ mobilePanHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ mobilePanHistoriesPagedStartAndEnd.start }} - {{ mobilePanHistoriesPagedStartAndEnd.end }} of {{
            mobilePanHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="mobilePanHistoriesCount" [itemsPerPage]="mobilePanHistoriesPerPage" [currentPage]="mobilePanHistoriesCurrentPage" (pageChange)="onMobilePanHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- PHONEPE FASTAG HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'phonepe_fastag'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="phonepeFastagHistoriesSelectAll.isSelected" (click)="onPhonepeFastagHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of phonepeFastagHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let phonepeFastagHistoryPaged of phonepeFastagHistoriesPaged" (click)="goToPhonepeFastagHistoryResult(phonepeFastagHistoryPaged)" style="cursor: pointer;">
                                <td class="search-history-table-td" (click)="$event.stopPropagation()">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="phonepeFastagHistoryPaged.isSelected" (click)="onPhonepeFastagHistoryPagedClick($event, phonepeFastagHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of phonepeFastagHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ phonepeFastagHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ phonepeFastagHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ phonepeFastagHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ phonepeFastagHistoriesPagedStartAndEnd.start }} - {{ phonepeFastagHistoriesPagedStartAndEnd.end }} of {{
            phonepeFastagHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="phonepeFastagHistoriesCount" [itemsPerPage]="phonepeFastagHistoriesPerPage" [currentPage]="phonepeFastagHistoriesCurrentPage" (pageChange)="onPhonepeFastagHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- PHONEPE UPI HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'phonepe_upi'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="phonepeUpiHistoriesSelectAll.isSelected" (click)="onPhonepeUpiHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of phonepeUpiHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let phonepeUpiHistoryPaged of phonepeUpiHistoriesPaged" (click)="goToPhonepeUpiHistoryResult(phonepeUpiHistoryPaged)" style="cursor: pointer;">
                                <td class="search-history-table-td" (click)="$event.stopPropagation()">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="phonepeUpiHistoryPaged.isSelected" (click)="onPhonepeUpiHistoryPagedClick($event, phonepeUpiHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of phonepeUpiHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ phonepeUpiHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ phonepeUpiHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ phonepeUpiHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ phonepeUpiHistoriesPagedStartAndEnd.start }} - {{ phonepeUpiHistoriesPagedStartAndEnd.end }} of {{
            phonepeUpiHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="phonepeUpiHistoriesCount" [itemsPerPage]="phonepeUpiHistoriesPerPage" [currentPage]="phonepeUpiHistoriesCurrentPage" (pageChange)="onPhonepeUpiHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- VIRTUAL NUMBER HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'virtual-number'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="virtualNumberHistoriesSelectAll.isSelected" (click)="onVirtualNumberHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of virtualNumberHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let virtualNumberHistoryPaged of virtualNumberHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="virtualNumberHistoryPaged.isSelected" (click)="onVirtualNumberHistoryPagedClick($event, virtualNumberHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of virtualNumberHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ virtualNumberHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ virtualNumberHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ virtualNumberHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ virtualNumberHistoriesPagedStartAndEnd.start }} - {{ virtualNumberHistoriesPagedStartAndEnd.end
            }} of {{
            virtualNumberHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="virtualNumberHistoriesCount" [itemsPerPage]="virtualNumberHistoriesPerPage" [currentPage]="virtualNumberHistoriesCurrentPage" (pageChange)="onVirtualNumberHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- ADVANCED SEARCH HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'advanced-search'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="advancedSearchHistoriesSelectAll.isSelected" (click)="onAdvancedSearchHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of advancedSearchHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let advancedSearchHistoryPaged of advancedSearchHistoriesPaged">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="advancedSearchHistoryPaged.isSelected" (click)="onAdvancedSearchHistoryPagedClick($event, advancedSearchHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of advancedSearchHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ advancedSearchHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ advancedSearchHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ advancedSearchHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ advancedSearchHistoriesPagedStartAndEnd.start }} - {{ advancedSearchHistoriesPagedStartAndEnd.end
            }} of {{
            advancedSearchHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="advancedSearchHistoriesCount" [itemsPerPage]="advancedSearchHistoriesPerPage" [currentPage]="advancedSearchHistoriesCurrentPage" (pageChange)="onAdvancedSearchHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- BASIC SEARCH HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'basic-search'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="basicSearchHistoriesSelectAll.isSelected" (click)="onBasicSearchHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of basicSearchHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="search-history-table-row-clickable" *ngFor="let basicSearchHistoryPaged of basicSearchHistoriesPaged" (click)="onBasicSearchHistoryRowClick(basicSearchHistoryPaged)">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="basicSearchHistoryPaged.isSelected" (click)="onBasicSearchHistoryPagedClick($event, basicSearchHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of basicSearchHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ basicSearchHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ basicSearchHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ basicSearchHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ basicSearchHistoriesPagedStartAndEnd.start }} - {{ basicSearchHistoriesPagedStartAndEnd.end }} of {{
            basicSearchHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="basicSearchHistoriesCount" [itemsPerPage]="basicSearchHistoriesPerPage" [currentPage]="basicSearchHistoriesCurrentPage" (pageChange)="onBasicSearchHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- WEB SEARCH HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'web-search'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <th class="search-history-table-th">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="webSearchHistoriesSelectAll.isSelected" (click)="onWebSearchHistoriesSelectAllClick()" />
                                </th>
                                <ng-container *ngFor="let tableHeader of webSearchHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="search-history-table-row-clickable" *ngFor="let webSearchHistoryPaged of webSearchHistoriesPaged" (click)="onWebSearchHistoryRowClick(webSearchHistoryPaged)">
                                <td class="search-history-table-td">
                                    <input class="search-history-checkbox" type="checkbox" [checked]="webSearchHistoryPaged.isSelected" (click)="onWebSearchHistoryPagedClick($event, webSearchHistoryPaged)" />
                                </td>
                                <ng-container *ngFor="let tableData of webSearchHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ webSearchHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ webSearchHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ webSearchHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ webSearchHistoriesPagedStartAndEnd.start }} - {{ webSearchHistoriesPagedStartAndEnd.end }} of {{
            webSearchHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="webSearchHistoriesCount" [itemsPerPage]="webSearchHistoriesPerPage" [currentPage]="webSearchHistoriesCurrentPage" (pageChange)="onWebSearchHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- LINK ANALYSIS HISTORIES -->
        <div class="row" *ngIf="selectedHistoryTab.type === 'link-analysis'">
            <div class="col-12 p-sm-0">
                <div class="table-responsive search-history-table-wrapper">
                    <table class="table search-history-table">
                        <thead>
                            <tr>
                                <ng-container *ngFor="let tableHeader of linkAnalysisHistoryTableThs">
                                    <th class="search-history-table-th">{{ tableHeader }}</th>
                                </ng-container>
                                <th class="search-history-table-th">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="search-history-table-row-clickable" *ngFor="let linkAnalysisHistoryPaged of linkAnalysisHistoriesPaged" (click)="onLinkAnalysisHistoryRowClick(linkAnalysisHistoryPaged)">
                                <ng-container *ngFor="let tableData of linkAnalysisHistoryTableTds">
                                    <td class="search-history-table-td">
                                        <ng-container [ngSwitch]="tableData.type">
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ linkAnalysisHistoryPaged[tableData.field] | date : 'mediumDate' }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'time'">
                                                {{ linkAnalysisHistoryPaged[tableData.field] | date : 'shortTime' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ linkAnalysisHistoryPaged[tableData.field] }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <td class="search-history-table-td search-history-table-td-active">
                                    Open graph
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 p-sm-0">
                <div class="search-history-bottom-bar">
                    <div class="search-history-count">
                        Showing {{ linkAnalysisHistoriesPagedStartAndEnd.start }} - {{ linkAnalysisHistoriesPagedStartAndEnd.end
            }} of {{
            linkAnalysisHistoriesCount }} Results
                    </div>
                    <div class="search-history-paginator">
                        <app-paginator [totalItems]="linkAnalysisHistoriesCount" [itemsPerPage]="linkAnalysisHistoriesPerPage" [currentPage]="linkAnalysisHistoriesCurrentPage" (pageChange)="onLinkAnalysisHistoriesPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
